// T3-B sponsored motif (PR 4, 2026-05-07): sponsors CRUD endpoints HTTP client.
// api 側 implementation: omikuji-api PR #97 (PR 2 CMS CRUD API)。
//
// auth: ADMIN only。

import ApiService from './ApiService';

export default class SponsorApi extends ApiService {
    // GET /system/sponsors?industry=&page=&limit=
    list(payload?: any) {
        return this.get('sponsors', payload);
    }

    getById(id: string | number) {
        return this.get(`sponsors/${id}`);
    }

    create(payload: any) {
        return this.post('sponsors', payload);
    }

    update(payload: { id: string | number, data: any }) {
        const { id, data } = payload;
        return this.put(`sponsors/${id}`, data);
    }

    remove(id: string | number) {
        return this.delete(`sponsors/${id}`);
    }
}
